import React from 'react';
import { Field } from '../../../types';

interface SmallComponentProps {
  field: Field
}

function SmallComponent(props: SmallComponentProps) {
  const { field } = props;
  return (
    <div className="mb-4">
      <p className="terms ps-2 kb-border-start">
        {field.label
        && (
        <>
          <strong>{field.label}</strong>
          <br />
        </>
        )}
        <span dangerouslySetInnerHTML={{ __html: field.text || field.value }}>
          {/* {} */}
        </span>
      </p>
    </div>
  );
}

export default SmallComponent;
